import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { divisionsActions } from '../actions/divisions.actions';
import { selectDivisions, selectLoaded, selectLoading, selectLookup, selectLookupLoaded, selectTotal } from '../selectors/divisions.selector';

@Service()
export class DivisionsFacade {
    private readonly store = inject(Store);

    readonly divisions = this.store.selectSignal(selectDivisions);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);
    readonly lookupLoaded = this.store.selectSignal(selectLookupLoaded);
    readonly lookup = this.store.selectSignal(selectLookup);

    getDivisions(page: number, limit: number): void {
        this.store.dispatch(divisionsActions.getDivisions({ value: { page, limit } }));
    }

    getDivisionsLookup(): void {
        this.store.dispatch(divisionsActions.getDivisionsLookup());
    }

    clear(): void {
        this.store.dispatch(divisionsActions.clear());
    }
}
